var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimesCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8889 40.1111L33 33M33 33L40.1111 25.8889M33 33L25.8889 25.8889M33 33L40.1111 40.1111M65 33C65 37.2023 64.1723 41.3635 62.5641 45.2459C60.956 49.1283 58.5989 52.6559 55.6274 55.6274C52.6559 58.5989 49.1283 60.956 45.2459 62.5641C41.3635 64.1723 37.2023 65 33 65C28.7977 65 24.6365 64.1723 20.7541 62.5641C16.8717 60.956 13.3441 58.5989 10.3726 55.6274C7.40111 52.6559 5.04401 49.1283 3.43585 45.2459C1.8277 41.3635 1 37.2023 1 33C1 24.5131 4.37142 16.3737 10.3726 10.3726C16.3737 4.37142 24.5131 1 33 1C41.4869 1 49.6263 4.37142 55.6274 10.3726C61.6286 16.3737 65 24.5131 65 33Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimesCircle);
export default __webpack_public_path__ + "static/media/times-circle.a368b5f4fde807ab68c96dff66efc374.svg";
export { ForwardRef as ReactComponent };